<script lang="ts">
	import { _ } from 'svelte-i18n';
	import Avatar from '$lib/components/Avatar/Avatar.svelte';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { calculateRelativeTime } from '$lib/utils/calculateRelativeTime';
	import type { Notification } from '$lib/api/restApi';
	import type { Icon as IconType } from '$lib/components/Icon/Icon-types';
	import { getHubStores } from '$lib/stores/hubStores';

	const { hub } = getHubStores();

	export let notification: Notification;
	export let fullWidth = false;

	enum NotificationTypes {
		Like = 'like',
		Mention = 'mention',
		Invite = 'invite',
		Contribution = 'contribution',
	}

	let notificationIcon: IconType;
	if (notification.type === 'contribution') {
		notificationIcon = 'comment';
	} else {
		notificationIcon = notification.type as IconType;
	}
</script>

<div class="wrapper" class:fullWidth>
	<div class="innerWrapper">
		<Avatar name={notification.etc.user.name} url={notification.etc.user.avatar_url} />
		<span class="contentAndDate">
			{#if notification.type === NotificationTypes.Like}
				<a href={`${notification.etc.post?.url}`}>
					{$_('session.post.like.notification', {
						values: {
							user: notification.etc.user.name,
							post: notification.etc.post?.title || $_('activity.a.post'),
						},
					})}
				</a>
			{:else if notification.type === NotificationTypes.Mention}
				<a href={`${notification.etc.post?.url}`}>
					{`${notification.etc.user.name} ${$_('common.activity.mentioned.you.in')} ${
						notification.etc.post?.title || $_('activity.a.post')
					}`}
				</a>
			{:else if notification.type === NotificationTypes.Invite}
				<a href={`${notification.etc.hub?.url}`}>
					{$_('session.accepted.invite', {
						values: {
							userName: notification.etc.user.name,
							orgHubName: notification.etc.hub?.title,
							role: notification.etc.invite?.role,
						},
					})}
				</a>
			{:else if notification.type === NotificationTypes.Contribution}
				<a href={`${notification.etc.post?.url}`}>
					{`${notification.etc.user.name} ${$_('common.activity.commented.on')} ${
						notification.etc.post?.title || $_('activity.a.post')
					}`}
				</a>
			{/if}
			<span class="time">
				{calculateRelativeTime(notification.created_at, $hub.locale)}
			</span>
		</span>
	</div>
	<Icon icon={notificationIcon} size={'24'} color="#4c535d" />
</div>

<style>
	.wrapper {
		display: flex;
		align-items: center;
		inline-size: 250px;
		padding-block: var(--gutterMedium);
		padding-inline: var(--gutterSmall);
		border-block-end: solid 1px var(--grayLighter);
	}

	.wrapper.fullWidth {
		justify-content: space-between;
		inline-size: 100%;
	}

	.fullWidth .innerWrapper .contentAndDate {
		display: flex;
		flex-direction: column;
		gap: var(--gutterSmaller);
	}

	.innerWrapper {
		display: flex;
		align-items: center;
		margin-inline: var(--gutterMedium);
		font-size: var(--fontSizeSmaller);
		gap: var(--gutterDefault);
	}

	a {
		color: var(--grayDarkest);
		font-size: inherit;
		text-decoration: none;
	}

	.time {
		color: var(--grayDark);
	}
</style>
